import type { ReactNode } from 'react'
import {
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentTitle,
} from '@/components/ModalSheet'

export interface CardPaymentMethodEditorContentProps {
  children?: ReactNode
}

export function CardPaymentMethodEditorContent({
  children,
}: CardPaymentMethodEditorContentProps) {
  return (
    <>
      <ModalSheetContentBlock>
        <ModalSheetContentTitle>Add a Credit/Debit Card</ModalSheetContentTitle>
        <ModalSheetContentDescription>
          Enter your payment details below.
        </ModalSheetContentDescription>
      </ModalSheetContentBlock>
      <ModalSheetContentBlock>{children}</ModalSheetContentBlock>
    </>
  )
}
